// Cache for translation indexes to avoid rebuilding on every call
const translationIndexCache = new WeakMap()

/**
 * Builds a flat index of all translation keys for fast lookup
 * @param {Object} langs - Translation object with nested structure
 * @returns {Object} Flat index mapping keys to their values
 */
function buildTranslationIndex(langs) {
    const index = {}

    for (const group in langs) {
        if (langs.hasOwnProperty(group) && typeof langs[group] === "object" && langs[group] !== null) {
            for (const groupKey in langs[group]) {
                if (langs[group].hasOwnProperty(groupKey)) {
                    index[groupKey] = langs[group][groupKey]
                }
            }
        }
    }

    return index
}

/**
 * Gets translation index from cache or builds it if not exists
 * @param {Object} langs - Translation object
 * @returns {Object} Flat index of translations
 */
function getTranslationIndex(langs) {
    if (!translationIndexCache.has(langs)) {
        translationIndexCache.set(langs, buildTranslationIndex(langs))
    }
    return translationIndexCache.get(langs)
}

export default function t(key, langs, parameters, _default_index_key = "default_index_key") {
    if (!langs) {
        return key
    }

    // Fast path: check direct property first
    if (langs.hasOwnProperty(key)) {
        return langs[key]
    }

    // Use cached index for fast lookup instead of nested loops
    const index = getTranslationIndex(langs)
    let value = index[key]

    if (typeof value === "string" && typeof parameters === "object" && parameters !== null) {
        for (const [paramKey, paramValue] of Object.entries(parameters)) {
            if (paramValue) {
                if (value.includes(`:${paramKey}`)) {
                    value = value.replace(`:${paramKey}`, paramValue)
                } else {
                    value = value.replace(`${paramKey}`, paramValue)
                }
            }
        }
    }
    if (!value) {
        value = index[key + "." + _default_index_key]
    }

    return value ? value : key
}
